import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
// import { TranslationMeta, Translation } from "../../helper/transComp";
import PropTypes from "prop-types";

class Error404 extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "",
    };
  }
  static propTypes = {
    user: PropTypes.object,
  };

  componentDidMount() {
    if (this.props.user.language) {
      this.setState({ lang: `${this.props.user.language}/` });
    }
  }

  render() {
    return (
      <Fragment>
        {/* <TranslationMeta
          title={"KanbanTitle"}
          description={"KanbanDescription"}
          keywords={"KanbanKeyWords"}
          error={true}
        /> */}
        <main className="body404">
          <h1>Error404</h1>
        </main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user,
});

export default connect(mapStateToProps, {})(Error404);
